<template>
  <div class="bindPhone">
    <el-dialog
        :visible.sync="showBind"
        :show-close="true"
        :append-to-body="true"
        width="380px"
        lock-scroll
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :center="true"
        @close="closeBind"
        >
      <div class="dialogmain">
        <!-- <div class="closeicon" @click="closeBind">
            <svg-icon icon-class="close"></svg-icon>
        </div> -->
        <p class="bindTitle">微信账号绑定</p>
        <div class="userlogin">
            <el-form :model="loginForm" status-icon :rules="rules" ref="ruleForm">
                <el-form-item prop="Phone">
                    <el-input 
                        v-model="loginForm.Phone" 
                        placeholder="请输入手机号"
                        maxlength="11"
                        @input="inputPhone"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item prop="Code" class="getcode">
                    <el-input class="input" v-model="loginForm.Code" @keyup.enter.native="submitForm('ruleForm')" placeholder="请输入验证码"></el-input>
                    <el-button class="btn" :disabled="!canSend" @click="sendCode">{{codeNum?codeNum:"获取验证码"}}</el-button>
                </el-form-item>
                <el-form-item class="loginBtnForm">
                    <el-button type="primary" round @click="submitForm('ruleForm')" class="loginBtn" :loading="loading">提交</el-button>
                </el-form-item>
            </el-form>
            <div class="codemsg">
                请输入您的手机号完成绑定微信绑定成功即可登录
            </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  computed: {
    showBind: {
      get() {
        return this.$store.state.showBind;
      },
      set() {},
    },
  },
  data() {
    return {
      canSend:true,//获取验证码按钮禁用
      codeTimer:null,
      loading:false,
      codeNum:null,
      loginForm:{
        Phone:"",
        Code:"",
      },
      rules:{
        Phone: [
          { required: true, message: "请输入正确的手机号", trigger: "change" },
          {
              max: 11,
              message: "长度在11个字符",
              trigger: "change"
          }
        ],
        Code: [
          { required: true, message: "请输入验证码", trigger: "change" },
          { max: 6, message: "长度为6个字符", trigger: "change" }
        ]
      },
    }
  },
  methods: {
    closeBind() {
      this.$store.commit('changeShowBindStatus', false)
    },
    //输入手机号时触发
        inputPhone(val){
            if(val.length>11){
                this.loginForm.Phone = val.substring(0,11);
                // console.log("over")
            }
        },
        //发送验证码
        sendCode(){
            var _this = this;
            console.log(_this.loginForm.Phone)
            console.log(/^[1][3,4,5,7,8,9][0-9]{9}$/.test(_this.loginForm.Phone))
            if (!(/^[1][3,4,5,7,8,9][0-9]{9}$/.test(_this.loginForm.Phone))) {
                _this.$message({
                    type: "error",
                    message: "请输入正确的手机号格式"
                });
            }else{
              _this.$post('Member/v1/sendcode', {Phone: _this.loginForm.Phone}).then(res=>{
                  if (res.Code == 200) {
                      _this.$message({
                          type: "success",
                          message: res.Msg
                      });
                      _this.codeNum = 59;
                      _this.canSend = false;
                      this.codeTimer = setInterval(() => {
                          _this.codeNum--;
                          if (_this.codeNum == 0) {
                              _this.canSend = true;
                              clearInterval(this.codeTimer);
                              _this.codeNum = null;
                          }
                      }, 1000);
                  }
              })
          }
        },
        //提交
        submitForm(formName){
          this.$refs[formName].validate((valid) => {
              if (valid) {
                  this.loading = true;
                  setTimeout(()=>{
                      this.loading = false;
                  },3000)
                  this.codeNum = 0;
                  clearInterval(this.codeTimer);
                  this.canSend = true;
                  this.$store.commit("bindPhone",this.loginForm);
                  // this.$refs[formName].resetFields();
              } else {
                  // console.log('error submit!!');
                  return false;
              }
          });
      }
  }
}
</script>
<style lang="scss" scoped>
.dialogmain{
    position: relative;
    padding-top: 70px;
    .bindTitle{
        margin:0px 0 50px;
        text-align: center;
        font-size: 22px;
    }
    .closeicon{
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
    }
    .headtab{
      padding:80px 0 40px;
      text-align: center;
      color: #999;
      font-size: 18px;
      span{
        margin: 0 20px;
        cursor: pointer;
        position: relative;
        padding-bottom:10px;
        &::after{
            display: block;
            content: " ";
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 32px;
            height: 2px;
            background: transparent;
          }
        }
      .active{
        color: #333;
        &::after{
          background: #2075F5;
        }
      }
    }
    .userlogin{
        padding: 0 44px 50px;
        .getcode{
          .el-form-item__content{
            display: flex;
            .input {
              width: 50%;
            }
          .btn {
            height: 40px;
            margin-left: 12px;
            background: rgba($color: #2075F5, $alpha: 0.1);
            color: #2075F5;
            width: 112px;
          }
          }
        }
        .loginBtnForm{
            text-align: center;
            .loginBtn{
                font-size: 18px;
                padding: 16px 102px;
                border-radius: 25px;
                margin: 28px auto 0;
                background: #2075F5;
            }
        }
        .codemsg{
            padding-top: 40px;
            border-top: 1px solid #efefef;
            font-size: 14px;
            color: #777;
            text-align: center;
            margin-top: 50px;
        }
    }
    .wechatLogin{
        .wxCode{
            padding-left: 40px;
            .scodeShow{
                iframe{
                    display: block;
                    margin: 0 auto;
                }
            }
        }
        
    }
}
</style>


// WEBPACK FOOTER //
// src/components/login/bindPhone.vue